import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { merge } from 'rxjs';
import { WaterBodyDAO } from '../../../core/services/dao/waterBodyDAO';
import { CaptainDAO } from '../../../core/services/dao/captainDAO';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../core/services/apiHelper';
import { environment } from '../../../environments/environment';

@Injectable()
export class AllForHireResolve implements Resolve<any> {
  constructor(
    private waterBodyDAO: WaterBodyDAO,
    private captainDAO: CaptainDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const captainResolve = this.captainDAO.loadCaptainsForHire();
    const waterBodyResolve = this.waterBodyDAO.load();
    const mergeResolve = merge(waterBodyResolve, captainResolve);
    return mergeResolve.pipe(
      take(2),
      map((data) => data),
    );
  }
}
